// API Cache Types (Redis)
export enum CacheType {
  ALL = 'all',
  SIDEBAR = 'sidebar',
  TRENDING = 'trending',
  MENU = 'menu',
  SITEMAP = 'sitemap',
  PAGES = 'pages',
  BLOG_POSTS = 'blog-posts',
  ARTICLES = 'articles',
  LAYOUT = 'layout',
  ROBOT = 'robot',
}

export const CACHE_TYPE_LABELS: Record<CacheType, string> = {
  [CacheType.ALL]: 'Tất cả',
  [CacheType.SIDEBAR]: 'Sidebar',
  [CacheType.TRENDING]: 'Phim thịnh hành',
  [CacheType.MENU]: 'Menu',
  [CacheType.SITEMAP]: 'Sitemap',
  [CacheType.PAGES]: 'Trang',
  [CacheType.BLOG_POSTS]: 'Bài viết blog',
  [CacheType.ARTICLES]: 'Bài viết phim',
  [CacheType.LAYOUT]: 'Layout',
  [CacheType.ROBOT]: 'Robot.txt',
};

// Client Cache Types (Next.js)
export enum ClientCacheType {
  // Existing
  ALL = 'all',
  HOME = 'home',
  MOVIES = 'movies',
  NEWS = 'news',
  TRENDING = 'trending',
  PAGES = 'pages',
  LAYOUT = 'layout',

  // New types
  MOVIE_DETAIL = 'movie-detail',
  EPISODE = 'episode',
  CATEGORY = 'category',
  COUNTRY = 'country',
  YEAR = 'year',
  SEARCH = 'search',
  NEWS_DETAIL = 'news-detail',
  ACTOR = 'actor',
  DIRECTOR = 'director',
  SITEMAP = 'sitemap',
  ROBOT = 'robot',
}

export const CLIENT_CACHE_TYPE_LABELS: Record<ClientCacheType, string> = {
  [ClientCacheType.ALL]: 'Tất cả',
  [ClientCacheType.HOME]: 'Trang chủ',
  [ClientCacheType.MOVIES]: 'Danh sách phim',
  [ClientCacheType.NEWS]: 'Tin tức',
  [ClientCacheType.TRENDING]: 'Phim thịnh hành',
  [ClientCacheType.PAGES]: 'Trang tĩnh',
  [ClientCacheType.LAYOUT]: 'Layout (Header/Footer)',
  [ClientCacheType.MOVIE_DETAIL]: 'Chi tiết phim',
  [ClientCacheType.EPISODE]: 'Tập phim',
  [ClientCacheType.CATEGORY]: 'Thể loại',
  [ClientCacheType.COUNTRY]: 'Quốc gia',
  [ClientCacheType.YEAR]: 'Năm',
  [ClientCacheType.SEARCH]: 'Tìm kiếm',
  [ClientCacheType.NEWS_DETAIL]: 'Chi tiết tin tức',
  [ClientCacheType.ACTOR]: 'Diễn viên',
  [ClientCacheType.DIRECTOR]: 'Đạo diễn',
  [ClientCacheType.SITEMAP]: 'Sitemap',
  [ClientCacheType.ROBOT]: 'Robots.txt',
};

// Types that require slug input
export const DYNAMIC_CLIENT_CACHE_TYPES = [
  ClientCacheType.MOVIE_DETAIL,
  ClientCacheType.EPISODE,
  ClientCacheType.CATEGORY,
  ClientCacheType.COUNTRY,
  ClientCacheType.YEAR,
  ClientCacheType.NEWS_DETAIL,
  ClientCacheType.ACTOR,
  ClientCacheType.DIRECTOR,
  ClientCacheType.PAGES,
] as const;

// Statistics
export interface CacheTypeStats {
  type: CacheType;
  label: string;
  pattern: string;
  keyCount: number;
  keys: string[];
}

export interface CacheStats {
  totalKeys: number;
  byType: CacheTypeStats[];
  memoryUsage: {
    usedMemory: string;
    usedMemoryPeak: string;
    usedMemoryHuman: string;
  };
  redisVersion: string;
}

export interface CacheStatsResponse {
  success: boolean;
  data: CacheStats;
  message: string;
}

// Clear Cache
export interface ClearCacheResult {
  success: boolean;
  message: string;
  type?: CacheType;
  deletedKeys?: number;
  duration?: number;
}

export interface ClearCacheByTypeResponse {
  success: boolean;
  message: string;
  type: CacheType;
  deletedKeys: number;
  duration: number;
}

// Client Revalidation
export interface RevalidateClientDto {
  type: ClientCacheType;
  slug?: string;
  episodeSlug?: string;
  paths?: string[];
  tags?: string[];
}

export interface ClientRevalidationResult {
  success: boolean;
  message: string;
  clientResponse?: {
    success: boolean;
    revalidated: {
      paths: string[];
      tags: string[];
    };
    errors: string[];
    timestamp: string;
  };
  error?: string;
}

// Combined Operations
export interface ClearAndRevalidateResult {
  success: boolean;
  message: string;
  apiCache: {
    type: CacheType;
    deletedKeys: number;
    duration: number;
  };
  clientRevalidation: ClientRevalidationResult | null;
}

// Client Health Check
export interface ClientHealthResponse {
  available: boolean;
  url: string;
  message: string;
}
